import { h, Component } from 'preact';
import { MkComponent } from 'lib/mkjs/mkcomponent';
import ContactEntity from 'entities/contactentity';
import { TownshendUser } from 'lib/townshend/components/townshendentities';

//TODO move this into backend code or database; make extendable?;
//TODO make data model more complex as needed (complex arrays for email, address, etc)
const ALL_FIELDS = {
	name: {
		type: "string"
	},
	email: {
		type: "string",
		format: "email" //TODO implement validation
	},
	phone: {
		type: "string",
		format: "phone" //TODO implement validation
	},
	address1: {
		type: "string",
		title: "Address Line 1"
	},
	address2: {
		type: "string",
		title: "Address Line 2"
	},
	city: {
		type: "string"
	},
	state: {
		type: "string",
		enum: [
			"Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
			"Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
			"Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
			"Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
			"New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
			"Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
			"Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
			"Wisconsin", "Wyoming"
		]
	},
	zip: {
		type: "string"
	},
	birthday: {
		type: "string",
		format: "date"
	},
	// importantDates: {
	// 		type: "object",
	// 		properties: {
	// 			date: {
	// 				type: "string",
	// 				format: "date"
	// 			},
	// 			label: {
	// 				type: "string"
	// 			}
	// 		}
	// }
};

export default class ContactInfo extends MkComponent {
	getFieldComponent(fieldName, rs, subject) {
		const fieldComponents = {
			entity: this._fieldReference(ContactEntity),
			owner: this._fieldReference(TownshendUser, {nameFunc: item=>item.username}),
		}
		return fieldComponents[fieldName];
	}

	getFields(entity) {
		let fields = this.getEditableFields(entity);
		let nonnullFields = {}
		Object.keys(fields).forEach(key=> {
			if (fields[key]['$value']) {
				nonnullFields[key] = fields[key];
			}
		})
		return nonnullFields;
	}

	getIdentity(type, val) {
		return getIdentity(type, val, this.state.subject ? this.state.subject.entity : null);
	}

	getIdentityRequest(type, val) {
		return getVerification(type, val, this.state.subject ? this.state.subject.entity : null);
	}

	getEditableFields(entity) {
		let fields = {};
		Object.keys(ALL_FIELDS).forEach(key=>{
			fields[key] = Object.assign({}, ALL_FIELDS[key]);
			if (entity &&  entity.info && key in entity.info) {
				fields[key]['$value'] = entity.info[key];
			}
		});
		return fields;
	}

	prepareUpdate(subject, entity) {
		if (!entity.info) {
			entity.info = {};
		}
		let info = entity.info;
		Object.keys(subject).forEach(key=>{
			info[key] = subject[key];
		})
		return { info };
	}
}

function getIdentityOrVerification(type, val, field, entity) {
	//check to ensure that there are identities for this entity;
	if (entity && entity[field]) {
		let objects = entity[field]
		//check to see if this value matches any identifier in the entity's identities
		let ids = objects.filter(id=>(id.type === type && id.identifier === val));
		if (ids.length > 0) {
			if (ids.length > 1) {
				console.error(`found multiple ${field} with `, ids);
			}
			return ids[0];
		}
	}
	return null;
}

export function getIdentity(type, val, entity) {
	return getIdentityOrVerification(type, val, "identities", entity);
}

export function getVerification(type, val, entity) {
	return getIdentityOrVerification(type, val, "identityVerifications", entity);
}



// WEBPACK FOOTER //
// ./entities/contactinfo/index.js